/**
 * Built-in action type plugins registration and exports for the Unios workflow engine.
 *
 * This module exports all built-in plugins and provides a function
 * to register them with the plugin system.
 */
import { registerFrontendPlugin } from "../frontend/registry.js";
import { registerActionPlugin } from "../registry.js";
// Import all built-in plugins
import { automationTaskPlugin } from "./automation-task/index.js";
import { commentBasicPlugin } from "./comment-basic/index.js";
import { inputFileUploadPlugin } from "./input-file-upload/index.js";
import { inputFormPlugin } from "./input-form/index.js";
import { linkExternalPlugin } from "./link-external/index.js";
import { submodulePlugin } from "./submodule/index.js";
import { webhookWaitPlugin } from "./webhook-wait/index.js";
/**
 * All built-in action type plugins.
 */
export const builtInPlugins = [
    commentBasicPlugin,
    inputFormPlugin,
    inputFileUploadPlugin,
    automationTaskPlugin,
    linkExternalPlugin,
    webhookWaitPlugin,
    submodulePlugin,
];
/**
 * Register all built-in plugins with the registry.
 *
 * Call this function at application startup to make all
 * built-in action types available.
 * @example
 * ```typescript
 * import { registerBuiltInPlugins } from "@unios/action-plugins";
 *
 * // At application startup
 * registerBuiltInPlugins();
 * ```
 */
export function registerBuiltInPlugins() {
    for (const plugin of builtInPlugins) {
        registerActionPlugin(plugin);
        // Cast components to FrontendPluginComponents since the generic types are compatible at runtime
        registerFrontendPlugin(plugin.slug, plugin.components);
    }
}
// Re-export individual plugins for direct access
export { commentBasicPlugin } from "./comment-basic/index.js";
export { inputFormPlugin } from "./input-form/index.js";
export { inputFileUploadPlugin } from "./input-file-upload/index.js";
export { automationTaskPlugin } from "./automation-task/index.js";
export { linkExternalPlugin } from "./link-external/index.js";
export { webhookWaitPlugin } from "./webhook-wait/index.js";
export { submodulePlugin } from "./submodule/index.js";
// Re-export submodule utilities for consumers
export { SubmoduleContext, MAX_NESTING_DEPTH, displayModes, } from "./submodule/index.js";
//# sourceMappingURL=index.js.map